/* eslint-disable no-unused-vars */
import React from "react";
// const BookingTabs = React.lazy(() =>
//   import("../views/viewBookingTable/viewBookingTabs")
// );
// const MainTabs = React.lazy(() =>
//   import("../views/CashBooking/CashBookingTabs")
// );

// const ScanedandManifestList = React.lazy(() =>
//   import("../views/viewBookingTable/ScanedandManifestList")
// );
// const ChildPacketScan = React.lazy(() =>
//   import("../views/viewBookingTable/ChildPacketScann")
// );
// const PrintManifest = React.lazy(() =>
//   import("../views/viewBookingTable/PrintManifest")
// );
// const AddPacketMapping = React.lazy(() =>
//   import("../views/Master/PacketingGuide/AddPacketMapping")
// );
// const ViewManifest = React.lazy(() => import("../views/ViewManifest"));
// const Truck = React.lazy(() => import("../views/viewBookingTable/Truck"));
// const AddPacket = React.lazy(() =>
//   import("../views/viewBookingTable/Addpacket")
// );
// const Calculator = React.lazy(() => import("../views/Calculater"));
// const BookedSuccessfull = React.lazy(() =>
//   import("../views/BookSuccessfull/index")
// );
// const Broadcast = React.lazy(() =>
//   import("../views/Broadcast")
// );
// const Master = React.lazy(() =>
//   import("../views/Master")
// );
// const CashbookingRateCard = React.lazy(() =>
//   import("../views/Master/RateCard/CashbookingRateCard")
// );
// const AllocateTemplate = React.lazy(() =>
//   import("../views/Master/RateCard/CashbookingRateCard/allocateTemplate")
// );
// const Pincode = React.lazy(() =>
//   import("../views/Master/PincodeMaster")
// );
// const CpOnbordingTabs = React.lazy(() =>
//   import("../views/Master/CpOnbordingTabs")
// );
// const RouteMaster = React.lazy(() =>
//   import("../views/Master/Route")
// );
// const FirstAndLastMileTAT = React.lazy(() =>
//   import("../views/Master/TAT/FirstAndLastMile")
// );
// const VehicleOnboard = React.lazy(() =>
//   import("../views/Master/VehicleOnboard")
// );
// const MiddleMileTAT = React.lazy(() =>
//   import("../views/Master/TAT/middleMile")
// );
// const MasterChild = React.lazy(() =>
//   import("../views/Master/RateCard/masterChild")
// );
// const PacketingGuide = React.lazy(() =>
//   import("../views/Master/PacketingGuide")
// );
// const PinCodeMapping = React.lazy(() =>
//   import("../views/Master/PinCodeMapping")
// );

//-------------------------MASTER START-----------------------------------//

import Master from "../views/Master";
import AddPacketMapping from "../views/Master/PacketingGuide/AddPacketMapping";
import CashbookingRateCard from "../views/Master/RateCard/CashbookingRateCard";
import PincodeMaster from "../views/Master/PincodeMaster";
import RouteMaster from "../views/Master/Route";
import HubRouteMaster from "../views/Master/vehicleRoute";

import FirstAndLastMileTAT from "../views/Master/TAT/FirstAndLastMile";
import VehicleOnboard from "../views/Master/VehicleOnboard";
import MiddleMileTAT from "../views/Master/TAT/middleMile";
import MasterChild from "../views/Master/RateCard/masterChild";
import PacketingGuide from "../views/Master/PacketingGuide";
import PinCodeMapping from "../views/Master/PinCodeMapping";
import TatConfiguration from "../views/Master/TAT/TatConfiguration";
import TatCalulator from "../views/Master/TAT/TatCalculator";
import VehicleMaster from "../views/Master/Vehicle";
import SortingGuide from "../views/Master/SortingGuide";
import HubOnboarding from "../views/Master/HubOnboard";
import AllocateTemplate from "../views/Master/RateCard/CashbookingRateCard/allocateTemplate";
import VayuQuickPincodeMapping from "../views/Master/VayuQuickPincodeMapping";
import PincodeMap from "../views/PincodeMap"; // Import new view
// import AccountCreateTemplate from "../views/Master/RateCard/AccountBookingRateCard/AccountCreateTemplate";
// import ViewDetails from "../views/Master/CpOnbordingSteps/ViewDetails";
// import CpOnbordingTabs from "../views/Master/CpOnbordingTabs";

//-------------------------MASTER END-----------------------------------//

//-------------------------FIRST MILE START-----------------------------------//

import BookingTabs from "../views/viewBookingTable/viewBookingTabs";
import RetailBooking from "../views/FirstMile/RetailBooking";
import ScanedandManifestList from "../views/viewBookingTable/ScanedandManifestList";
import ChildPacketScan from "../views/viewBookingTable/ChildPacketScann";
import PrintManifest from "../views/viewBookingTable/PrintManifest";
import ViewManifest from "../views/viewBookingTable/viewBookingTabs/ViewManifest";
import Truck from "../views/viewBookingTable/Truck";
import AddPacket from "../views/viewBookingTable/Addpacket";
import NewBookedSuccessfull from "../views/FirstMile/RetailBooking/BookingSuccess";

import CPEWayBill from "../views/EwayBill/CPEwayBill";
import LastMileEWayBill from "../views/EwayBill/LastMileEwayBill";
import printEwayBill from "../views/EwayBill/PrintEwayBill/index";

//-------------------------FIRST MILE END-----------------------------------//

//----------------------------Middle Mile START---------------------------------------//
import AuditTabs from "../views/MiddleMileOperations/Audit";
import ConsolidatedList from "../views/MiddleMileOperations/InScan";
import PrintConsolidatedManifest from "../views/MiddleMileOperations/InScan/PrintConsolidatedManifest";
import CreateTrip from "../views/MiddleMileOperations/LCRGeneration/createTrip";
import LcrList from "../views/MiddleMileOperations/Outscan&Lcr/LcrList";
import PrintLcr from "../views/MiddleMileOperations/Outscan&Lcr/PrintLcr";
import ManifestList from "../views/MiddleMileOperations/ManifestList/index";
import UpdateTripList from "../views/MiddleMileOperations/Outscan&Lcr/UpdateTripList";
import AuditScannedTable from "../views/MiddleMileOperations/AuditScannedTable";
import ViewSortingMM from "../views/MiddleMileOperations/Sorting";
// import Packeting from "../views/MiddleMileOperations/HubPacketing";
import Bagging from "../views/MiddleMileOperations/Bagging/baggingTab";
import LcrTab from "../views/MiddleMileOperations/LCRGeneration/LcrTab";
import LCR from "../views/MiddleMileOperations/LCR";
import Tracker from "../views/MiddleMileOperations/Tracker";
import SortToCp from "../views/MiddleMileOperations/SortToCp";
import CalendarView from "../views/MiddleMileOperations/TripScheduler/CalendarView";
import ExcessInscan from "../views/MiddleMileOperations/ExcessInscan";
import EwayTracker from "../views/MiddleMileOperations/EwayTracker";
import LCRListScan from "../views/MiddleMileOperations/LCRInScanList";
import LCRScanList from "../views/MiddleMileOperations/LCRScanList";

import HubManifestEWayBill from "../views/EwayBill/HubManifestEwayBill";
import HubEWayBill from "../views/EwayBill/HubEwayBill";
import ExtendEWayBill from "../views/EwayBill/ExtendEwayBill";
import Audits from "../views/Audit";

import UpdateTripSchedule from "../views/MiddleMileOperations/TripScheduler/UpdateTripSchedule";
import CreateOrUpdateTrip from "../views/MiddleMileOperations/Outscan&Lcr/CreateOrUpdateTrip";
import ShipmentListReport from "../views/MiddleMileOperations/LCR/ShipmentReport/shipmentListReport";
import OutscanManifestList from "../views/MiddleMileOperations/OutscanManifest";
import ExceptionReport from "../views/MiddleMileOperations/ExceptionReports";

import OutgoingLCRReport from "../views/Master/Reports/OutgoingLCRReport/index.jsx";

// import LCRBagInScan from "../views/MiddleMileOperations/BagScannig";
// import OpenBag from "../views/MiddleMileOperations/OpenBag";
//import Bagging from "../views/MiddleMileOperations/Bagging";
// import LcrPacketsInScan from "../views/MiddleMileOperations/LCRPackets";
// import InScan from "../views/MiddleMileOperations/InScan";
// import AllManifestInScan from "../views/MiddleMileOperations/InScan/manifestInscan";

//----------------------------Middle Mile END---------------------------------------//

//----------------------------LastMileOperations START-----------------------------------//

import DrsGeneration from "../views/LastMileOperations/DrsGeneration/index";
import InScanCP from "../views/LastMileOperations/InScanCP";
import CreateVirtualArea from "../views/LastMileOperations/VirtualArea";
import DrsDetails from "../views/LastMileOperations/DrsGeneration/DrsDetails";
import printDrs from "../views/LastMileOperations/DrsGeneration/printDrs";
import PrintGenerateManifest from "../views/PrintGenerateManifest";
import PendingDrs from "../views/LastMileOperations/PendingDrs";
import CashRTo from "../views/LastMileOperations/RTO/CashRto";
import CreditRTO from "../views/LastMileOperations/RTO/CreditRto";
// import CreateVirtualArea from "../views/LastMileOperations/CreateVirtualArea";

//----------------------------LastMileOperations END-----------------------------------//

//----------------------------Stationary START---------------------------------------//

import AddCategory from "../views/HoStationary/AddCategory/inedx";
import AddProduct from "../views/HoStationary/AddProduct";
import ProductCP from "../views/CPStationary/Product";
import ProductDetails from "../views/CPStationary/Product/productDetails";
import HoStationary from "../views/HoStationary";
import ProductTabs from "../views/HoStationary/productTabs";
import OrderRequest from "../views/HoStationary/OrderRequest";
import CartPage from "../views/CPStationary/Cart";
import OrderHistory from "../views/CPStationary/Order";
import OrderDetails from "../views/CPStationary/Order/orderDetails";
//----------------------------Stationary END---------------------------------------//

// import GenerateManifest from "../views/GenerateManifest";
import GenerateManifestTabs from "../views/GenerateManifestTabs";
import ExcesInscan from "../views/ExcesInscan";
import StateMaster from "../views/StateMaster/index";
import PrsGenerationTab from "../views/PrsGeneration/PrsGenerationTab";

import VehicleList from "../views/Report/Vehicle";
import TripListByVehicle from "../views/Report/Vehicle/tripList";
import VehicleCkinCkout from "../views/Report/VehicleCkinCkout";
import HubReconciliation from "../views/HubReconciliation";
import StartReconciliation from "../views/HubReconciliation/StartReconciliation";
import HubReconciliationReportView from "../views/HubReconciliation/ReportView";

// CP Onboarding New

import CpOnboardingNew from "../views/CpOnboardingNew/index";
import KycView from "../views/CpOnboardingNew/KycView";

import CpLeadGen from "../views/LeadGenerationCP";
import ClientLeadList from "../views/LeadGenerationClient";
import CPLeadList from "../views/CPLeadList";
import ClientLeadGeneration from "../views/LeadGenerationClient/LeadGenClientSteps";
import ClientQuotationList from "../views/LeadGenerationClient/CreateQuoteList";
import CPQuotationList from "../views/LeadGenerationCP/CPQuotationList";

import NewQuotation from "../views/LeadGenerationClient/NewQuote";
import CPNewQuotation from "../views/LeadGenerationCP/AllocateRateCard";

import ScheduleMeetingModal from "../views/ClientLeadList/ScheduleMeetingModal";
import SendEmailModal from "../views/ClientLeadList/SendEmailModal";
import CPApprovalLeadList from "../views/AllApprovals/CPLeadApproval";
import LeadDetails from "../views/AllApprovals/CPLeadApproval/LeadDetails";
import { BillingConfiguration } from "../views/BillingConfiguration";
// import BillingConfiguration from "../views/BillingConfiguration";
// import BillingConfiguration from "../views/BillingConfiguration/BillingConfiguration";

import LeadApprovalConfirmation from "../views/AllApprovals/LeadApprovalConfirmation";
import AllApprovals from "../views/AllApprovals";
import RequestBranch from "../views/RequestBranch/index";
import ViewApprovalDPBasicDetails from "../views/AllApprovals/ClientLeadApproval/ClientLeadDetails";
import ViewPincodeMap from "../views/AllApprovals/ClientLeadApproval/viewPincodeMap";
import ViewRateCard from "../views/AllApprovals/ClientLeadApproval/viewRateCard";

import { Stationary } from "../views/middleMileSubRoutes";

import Broadcast from "../views/Broadcast";

import StaffOnboarding from "../views/onboarding_/StaffOnboarding";
import constants from "../constants/constants";

import "antd/dist/antd.css";
import "../App.scss";
import RateCardList from "../views/RateCardList";
import CrediteBooking from "../views/FirstMile/CrediteBooking";
import Discount from "../views/FirstMile/RetailBooking/ApplyDiscount";
import DiscountedList from "../views/FirstMile/RetailBooking/DiscountedList";
import NewRetailUX from "../views/FirstMile/RetailBooking/NewRetailUX";
import ShipmentTracker from "../views/ShipmentTracker";
import ShipmentDetails from "../views/ShipmentDetailsUI";
import BagDetails from "../views/BagDetailsUi";
import CPWiseHubManifestEWayBill from "../views/EwayBill/CPWiseHubManifestEWayBill";
import LCRGenerationNew from "../views/MiddleMileOperations/LCRGenerationNew";
import LCRReportNew from "../views/MiddleMileOperations/LCRReportNew";
import LCRThreshold from "../views/LCRThreshold";
import AllReports from "../views/MiddleMileOperations/ExceptionReports/allReports";
import HubToPinCodeMapping from "../views/Master/HubPinCodeMapping";
import HubCpLinking from "../views/Master/HubCpLinking";
import HubToCpMaster from "../views/Master/HubCpMaster";
import DrsMaster from "../views/Master/DRSMaster";
import ReportTiles from "../views/MiddleMileOperations/ExceptionReports/DataZipReports";
import BookedVsAuditedReport from "../views/Master/Reports/BookedVsAuditedReport";
import ReportConfigManager from "../views/Master/ReportConfigManager";
import DynamicReport from "../views/Master/Reports/DynamicReport";
import DynamicReportsList from "../views/Master/Reports/DynamicReportsList";
import BookingStatusReport from "../views/Master/Reports/BookingStatusReport";
import BookingInscanOutscanReport from "../views/Master/Reports/BookingInscanOutscanReport";
import HubAuditEntryReport from "../views/Master/Reports/HubAuditEntryReport";
import IncomingBagReport from "../views/Master/Reports/IncomingBagReport";
import OutgoingBagReport from "../views/Master/Reports/OutgoingBagReport";
import FastTrackReport from "../views/Master/Reports/FastTrackReport";
import DeliveryMISReport from "../views/Master/Reports/DeliveryMISReport";
import DeliveryMISReportNew from "../views/Master/Reports/DeliveryMISReportNew";
import DeliveryDetails from "../views/Master/Reports/DeliveryDetails";
import OutgoingShipmentReport from "../views/Master/Reports/OutgoingShipmentReport";
import IncomingShipmentReport from "../views/Master/Reports/IncomingShipmentReport";
import AccountBookings from "../views/Master/Reports/AccountBookings";
import CashBooking from "../views/Master/Reports/CashBooking";
import HubOpsDashboard from "../views/Master/Reports/HubOpsDashboard";
import DeliveryDashboard from "../views/Master/Reports/DeliveryDashboard";
import DirectorDashboard from "../views/Master/Reports/DirectorDashboard";
import ZoneWiseView from "../views/MiddleMileOperations/DirectorDashboard/ZoneWiseView";
import HubWiseView from "../views/MiddleMileOperations/DirectorDashboard/HubWiseView";
import CPWiseView from "../views/MiddleMileOperations/DirectorDashboard/CPWiseView";
import ZoneList from "../views/MiddleMileOperations/DirectorDashboard/ZoneList";
import DirectorDashboard3 from "../views/MiddleMileOperations/DirectorDashboard3";
import ZoneWiseView3 from "../views/MiddleMileOperations/DirectorDashboard3/ZoneWiseView3";
import HubWiseView3 from "../views/MiddleMileOperations/DirectorDashboard3/HubWiseView3";
import CPWiseView3 from "../views/MiddleMileOperations/DirectorDashboard3/CPWiseView3";
import ZoneList3 from "../views/MiddleMileOperations/DirectorDashboard3/ZoneList3";
import HubOpsZoneWiseView from "../views/MiddleMileOperations/DirectorDashboard3/HubOpsZoneWiseView";
import CentralOpsDashboard from "../views/MiddleMileOperations/CentralOpsDashboard";
import ZoneWiseViewCentralOps from "../views/MiddleMileOperations/CentralOpsDashboard/ZoneWiseViewCentralOps";
import HubWiseViewCentralOps from "../views/MiddleMileOperations/CentralOpsDashboard/HubWiseViewCentralOps";
import CPWiseViewCentralOps from "../views/MiddleMileOperations/CentralOpsDashboard/CPWiseViewCentralOps";
import ZoneListCentralOps from "../views/MiddleMileOperations/CentralOpsDashboard/ZoneListCentralOps";
import BookingVolumeReports from "../views/Master/Reports/BookingVolumeReports";
import VayuQuickPro from "../views/Master/Reports/VayuQuickPro";
import IncomingLCRReport from "../views/Master/Reports/IncomingLCRReport/index.jsx";
import InscanVsAuditReport from "../views/Master/Reports/InscanVsAuditReport/index.jsx";
import TotalAssignedClickableReport from "../views/Master/Reports/InscanVsAuditReport/TotalAssignedClickableReport/index.jsx";
import InscannedAtTransitClickableReport from "../views/Master/Reports/InscanVsAuditReport/InscannedAtTransitClickableReport/index.jsx";
import InscannedClickableReport from "../views/Master/Reports/InscanVsAuditReport/InscannedClickableReport/index.jsx";
import HubInscannedClickableReport from "../views/Master/Reports/InscanVsAuditReport/HubInscannedClickableReport/index.jsx";
import TotalAvailableShipmentsClickableReport from "../views/HubCPOverview/ClickableReport/TotalAvailableShipmentsClickableReport/index.jsx";
import InboundPendencyClickableReport from "../views/HubCPOverview/ClickableReport/InboundPendencyClickableReport/index.jsx";
import OutscanPendingInscanToHubClickableReport from "../views/HubCPOverview/ClickableReport/OutscanPendingInscanToHubClickableReport/index.jsx";
import OutscanPendingInscanToCpClickableReport from "../views/HubCPOverview/ClickableReport/OutscanPendingInscanToCpClickableReport/index.jsx";
import TotalAuditedClickableReport from "../views/Master/Reports/InscanVsAuditReport/TotalAuditedClickableReport/index.jsx";
import NotAuditedClickableReport from "../views/Master/Reports/InscanVsAuditReport/NotAuditedClickableReport/index.jsx";
import TatAnalysisReports from "../views/Master/Reports/TatAnalysisReports/index.jsx";
import PinCodeActiveInactiveTimelineReports from "../views/Master/Reports/PinCodeActiveInactiveTimelineReports/index.jsx";
import PincodeDiscrepanciesReport from "../views/Master/Reports/PincodeDiscrepanciesReport/index.jsx";
import DetailedInOutView from "../views/MiddleMileOperations/DetailedInOutView/index.js";
import OdaDrsStatusUpdateAdoption from "../views/Master/Reports/OdaDrsStatusUpdateAdoption/index.jsx";
import ControlTowerReportsNew from "../views/Master/Reports/ControlTowerReportsNew/index.jsx";
//import Guides from "../views/Guides";
// import LeadGenList from "../views/LeadGeneration";
// import OnborginTabs from "../views/Onbording";
// import ClientOnboarding from "../views/onboarding_/ClientOnboarding";
// import ClientTable from "../views/onboarding_/ClientOnboarding/viewClientTable";
// import ViewClientDetails from "../views/onboarding_/ClientOnboarding/ViewClientDetails";

import TransitLCRReport from "../views/Master/Reports/TransitLCRReport/index.jsx";
import DeliveryStatusReport from "../views/Master/Reports/DeliveryStatusReport";
import OutscanVsCpInscanReport from "../views/Master/Reports/OutscanVsCpInscanReport";
import OutscanByHubToBranch from "../views/Master/Reports/OutscanVsCpInscanReport/OutscanByHubToBranch";
import DeliveryScanByBranch from "../views/Master/Reports/OutscanVsCpInscanReport/DeliveryScanByBranch";
import DrsByOtherCpReport from "../views/Master/Reports/OutscanVsCpInscanReport/DrsByOtherCpReport";
import SameDayDeliveryByOtherCpReport from "../views/Master/Reports/OutscanVsCpInscanReport/SameDayDeliveryByOtherCpReport";
import SameDayDeliveryClickableReport from "../views/Master/Reports/OutscanVsCpInscanReport/SameDayDeliveryClickableReport";
import NotInscannedByCpClickableReport from "../views/Master/Reports/OutscanVsCpInscanReport/NotInscannedByCpClickableReport";
import HubOutscanVsCpInscanReportA3 from "../views/Master/Reports/HubOutscanVsCpInscanReportA3";
import HubOutscanVsCpInscanClickableA3 from "../views/Master/Reports/HubOutscanVsCpInscanReportA3/HubOutscanVsCpInscanClickableA3";


import HubAuditReport from "../views/Master/Reports/HubAuditReport/index.jsx";
import CpOutscanVsHubInscanReport from "../views/Master/Reports/CpOutscanVsHubInscanReport";
import HubInscanClickableReport from "../views/Master/Reports/CpOutscanVsHubInscanReport/HubInscanClickableReport";
import CpOutscanClickableReport from "../views/Master/Reports/CpOutscanVsHubInscanReport/CpOutscanClickableReport";
import EwayBillReport from "../views/Master/Reports/EwayBillReport";
import InscanReport from "../views/Master/Reports/InscanReport";
import MCNReport from "../views/Master/Reports/MCNReport";
import ForceShipmentReport from "../views/Master/Reports/ForceShipmentReport";
import ForceBagReport from "../views/Master/Reports/ForceBagReport";
import BookingVsDeliveryReport from "../views/Master/Reports/BookingVsDeliveryReport";
import WrongSortingReport from "../views/Master/Reports/WrongSortingReport";
import ForceAttemptBagReportCount from "../views/Master/Reports/ForceAttemptBagReportCount";
import ForceAttempShipmentDetails from "../views/Master/Reports/ForceAttemptBagReportCount/ForceAttempShipmentDetails";
import IncomingOutGoingShipmentDetails from "../views/Master/Reports/IncomingOutGoingShipmentDetails";

import ExcessInScanReport from "../views/Master/Reports/ExcessInScanReport/index.jsx";
import ExcessInScanEnhancedReport from "../views/Master/Reports/ExcessInScanEnhancedReport/index.jsx";
import HubwiseShipmentsInscanVsOutscanReport from "../views/Master/Reports/HubwiseShipmentsInscanVsOutscanReport/index.jsx";
import ShipmentInscanClickableReport from "../views/Master/Reports/HubwiseShipmentsInscanVsOutscanReport/ShipmentInscanClickableReport/index.jsx";
import ShipmentOutscanClickableReport from "../views/Master/Reports/HubwiseShipmentsInscanVsOutscanReport/ShipmentOutscanClickableReport/index.jsx";
import ShipmentPendingClickableReport from "../views/Master/Reports/HubwiseShipmentsInscanVsOutscanReport/ShipmentPendingClickableReport/index.jsx";

import FinalizedBagsPendingOutscanReport from "../views/Master/Reports/FinalizedBagsPendingOutscanReport/index.jsx";
import DBOnboarding from "../views/DBOnboarding";
import DeliveryPartnerList from "../views/DeliveryPartnerList";
import mcnOutBond from "../views/MiddleMileOperations/OutBondMcn/index.jsx";
import mcnInBond from "../views/MiddleMileOperations/InBondMcn/index.jsx";
import SmileLabelGeneration from "../views/MiddleMileOperations/SmileLabelGeneration/index.jsx";
import APILog from "../views/MiddleMileOperations/APILog/index.jsx";
import TrainingVideo from "../views/TrainingVideo/index.jsx";
import SupersetEmbeddedReport from "../views/Reports/EmbeddedSuperset";
import ShipmentInscannedVsWeightAuditedAdherenceReport from "../views/Master/Reports/ShipmentInscannedVsWeightAuditedAdherenceReport/index.jsx";
import DirectorDashboard2 from "../views/MiddleMileOperations/DirectorDashboard";
import HubCPOverview from "../views/HubCPOverview";
import HubManagerShipmentDetails from "../views/HubCPOverview/HubManagerShipmentDetails";
import ApprovalsCP from "../views/ApprovalsCP";
import HubAccess from "../views/HubAccess";
import MarkLostDamage from "../views/MarkLostDamage";
import ShipmentStatus from "../views/ShipmentStatus";
import MarkUndelivered from "../views/ShipmentStatus/MarkUndelivered";
import MarkReturnRevoke from "../views/ShipmentStatus/MarkReturnRevoke";
import BookingReport from "../views/Master/Reports/BookingReport";
import InscannedBagsReport from "../views/Master/Reports/InscannedBagsReport/index.jsx";
import RtoWithReasonReport from "../views/Master/Reports/RtoWithReasonReport/index.jsx";
import NonFtPremiumBookingsReport from "../views/Master/Reports/NonFtPremiumBookingsReport/index.jsx";
import PincodeManagement from "../views/Master/PincodeManagement/index.jsx";
import EscalationMatrix from "../views/EscalationMatrix";
import SupportAndContactView from "../views/SupportAndContact";
import LiveTicketsPage from "../views/LiveTickets";
import TATManagement from "../views/TATManagement";
import CreateTat from "../views/TATManagement/CreateTat";

const AuditedDetailsReport = React.lazy(() =>
  import("../views/Master/Reports/BookedVsAuditedReport/AuditedDetailsReport/index.jsx")
);
const TotalBookingsAuditReport = React.lazy(() =>
  import("../views/Master/Reports/BookedVsAuditedReport/TotalBookingsAuditReport/index.jsx")
);

const { ROLES } = constants;
const {
  CP_ADMIN,
  HO_ADMIN,
  HUB_ADMIN,
  ROLE_HOMARKETING,
  ROLE_ZONALHEAD,
  ROLE_ZONALOPERATOR,
  ROLE_RM,
  ROLE_FUNCTIONALHEAD,
  ROLE_MD,
  ROLE_CENTRALOPERATOR,
  ROLE_HOOPERATOR,
  ROLE_BOOKINGAUDITONLY,
  ROLE_HUBOPERATOR,
  DEVELOPER,
  CUSTOMER_DELIGHT_EXECUTIVE,
  ROLE_CSO,
  ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM
} = ROLES;

export const routeList = [
  {
    component: ShipmentDetails,
    route: "/shipment-details-ui",
    role: [DEVELOPER],
  },
  {
    component: BagDetails,
    route: "/bag-details-ui",
    role: [DEVELOPER],
  },
  {
    component: BookingTabs,
    route: "/viewBooking",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: PincodeMap,
    route: "/pincode-map",
    role: [
      HO_ADMIN,
      DEVELOPER,
      ROLE_FUNCTIONALHEAD,
      HUB_ADMIN,
      ROLE_ZONALHEAD,
      ROLE_ZONALOPERATOR,
      ROLE_RM,
      ROLE_MD,
      ROLE_CENTRALOPERATOR,
      ROLE_BOOKINGAUDITONLY,
      ROLE_HUBOPERATOR,
      CP_ADMIN,
      ROLE_HOMARKETING,
      ROLE_CSO,
      ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM,
    ],
  },
  {
    component: CpLeadGen,
    route: "/cp-lead-generation",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },

  {
    component: CPLeadList,
    route: "/cp-lead-generation-list",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: ClientLeadList,
    route: "/client-lead-generation-list",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: ClientLeadList,
    route: "/dp-lead-generation-list",
    role: [ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: ClientLeadGeneration,
    route: "/client-lead-generation/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: ClientLeadGeneration,
    route: "/client-lead-generation",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },

  {
    component: ViewApprovalDPBasicDetails,
    route: "/approve-dp/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: ViewPincodeMap,
    route: "/view-pincode-mapping/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },

  {
    component: ViewRateCard,
    route: "/view-rate-card/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: ClientQuotationList,
    route: "/quotation-list/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
    ROLE_HOMARKETING,
  },
  {
    component: CPQuotationList,
    route: "/cp-quotation-list/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
    ROLE_HOMARKETING,
  },
  {
    component: NewQuotation,
    route: "/client/:clientId/new-quotation/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: NewQuotation,
    route: "/new-quotation/:clientId",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },

  {
    component: CPNewQuotation,
    route: "/cp-quotation-new/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: CPNewQuotation,
    route: "/cp-quotation-edit/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: AllApprovals,
    route: "/all-approvals",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: DBOnboarding,
    route: "/db-onboarding",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: DeliveryPartnerList,
    route: "/delivery-partner-list",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: PrsGenerationTab,
    route: "/prs-generation",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    component: UpdateTripSchedule,
    route: "/create-schedule",
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, DEVELOPER],
  },
  {
    component: CPEWayBill,
    route: "/cp-eway-bill",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: HubManifestEWayBill,
    route: "/hub-manifest-eway/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: LastMileEWayBill,
    route: "/last-mile-eway-bill/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: HubEWayBill,
    route: "/hub-eway-bill/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: ExtendEWayBill,
    route: "/extend-eway",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },

  {
    component: NewRetailUX,
    route: "/retail-booking",
    role: [CP_ADMIN, DEVELOPER],
  },

  // {
  //   component: RetailBooking,
  //   route: "/retail-booking",
  //   role: [CP_ADMIN, DEVELOPER],
  // },
  {
    component: ScanedandManifestList,
    route: "/scan",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: ChildPacketScan,
    route: "/child-scan",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: PrintManifest,
    route: "/print",
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, DEVELOPER],
  },
  {
    component: Master,
    route: "/last-mile-operations",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: InScanCP,
    route: "/in-scan-cp",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: CreateVirtualArea,
    route: "/create-virtual-area",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: AddPacketMapping,
    route: "/addpacket-mapping",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: ViewManifest,
    route: "/view-manifest",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: Truck,
    route: "/truck",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: AddPacket,
    route: "/viewBooking-packet",
    role: [CP_ADMIN, DEVELOPER],
  },

  {
    component: NewBookedSuccessfull,
    route: "/retail-booking-success",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: Master,
    route: "/masters",
    role: [HO_ADMIN, HUB_ADMIN, DEVELOPER, ROLE_CENTRALOPERATOR, ROLE_HOOPERATOR, ROLE_CSO, ROLE_FUNCTIONALHEAD,
      ROLE_ZONALHEAD,
      ROLE_ZONALOPERATOR,
      ROLE_RM,
      ROLE_MD,
      ROLE_BOOKINGAUDITONLY,
      ROLE_HUBOPERATOR,
      CP_ADMIN,
      ROLE_HOMARKETING,
      ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM,
    ],
  },
  {
    component: CashbookingRateCard,
    route: "/cash-booking-ratecard",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: AllocateTemplate,
    route: "/allocate-template",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: RouteMaster,
    route: "/route-configuration",
    role: [HO_ADMIN, HUB_ADMIN, DEVELOPER, ROLE_CENTRALOPERATOR, ROLE_HOOPERATOR, ROLE_FUNCTIONALHEAD, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_MD, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: HubRouteMaster,
    route: "/hub-route-configuration",
    role: [HO_ADMIN, HUB_ADMIN, DEVELOPER, ROLE_CENTRALOPERATOR, ROLE_HOOPERATOR, ROLE_FUNCTIONALHEAD, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_MD, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: FirstAndLastMileTAT,
    route: "/first-last-mile-tat",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: PincodeMaster,
    route: "/pincode-master",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: PincodeManagement,
    route: "/pincode-management",
    role: [
      HO_ADMIN,
      DEVELOPER,
      ROLE_FUNCTIONALHEAD,
      HUB_ADMIN,
      ROLE_ZONALHEAD,
      ROLE_ZONALOPERATOR,
      ROLE_RM,
      ROLE_MD,
      ROLE_CENTRALOPERATOR,
      ROLE_BOOKINGAUDITONLY,
      ROLE_HUBOPERATOR,
      CP_ADMIN,
      ROLE_HOMARKETING,
      ROLE_CSO,
      ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM,
    ],
  },
  {
    component: CpLeadGen,
    route: "/cp-onboarding",
    role: [HO_ADMIN, CP_ADMIN, DEVELOPER],
  },
  {
    component: VehicleOnboard,
    route: "/vehicle-onboard",
    role: [CP_ADMIN, HUB_ADMIN, DEVELOPER],
  },
  {
    component: MiddleMileTAT,
    route: "/middle-mile-tat",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: MasterChild,
    route: "/master-card-child",
    role: [
      HO_ADMIN,
      DEVELOPER,
      HUB_ADMIN,
      ROLE_CENTRALOPERATOR,
      ROLE_HOOPERATOR,
      ROLE_FUNCTIONALHEAD,
      ROLE_ZONALHEAD,
      ROLE_ZONALOPERATOR,
      ROLE_HOCRM,
      ROLE_HO_CRM_CP,
      ROLE_DPCRM,
    ],
  },
  {
    component: PacketingGuide,
    route: "/packeting-guide",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: PinCodeMapping,
    route: "/pin-code-mapping",
    role: [HO_ADMIN, DEVELOPER],
  },

  {
    component: Broadcast,
    route: "/message-and-alerts",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: TATManagement,
    route: "/tatManagement",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: CreateTat,
    route: "/tatManagement/create",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: CreateTat,
    route: "/tatManagement/edit/:id",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: Master,
    route: "/onboarding-settings",
    role: [HO_ADMIN, CP_ADMIN, HUB_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: Master,
    route: "/approvals-settings",
    role: [HO_ADMIN, CP_ADMIN, HUB_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: ApprovalsCP,
    route: "/approvals-cp",
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, DEVELOPER],
  },
  {
    component: HubAccess,
    route: "/hub-access",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: MarkLostDamage,
    route: "/mark-lost-damage",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: ShipmentStatus,
    route: "/shipment-status",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: MarkUndelivered,
    route: "/mark-undelivered",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: MarkReturnRevoke,
    route: "/mark-return-revoke",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: HubReconciliation,
    route: "/hub-reconciliation",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: StartReconciliation,
    route: "/start-reconciliation",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: HubReconciliationReportView,
    route: "/hub-reconciliation-report",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: MarkUndelivered,
    route: "/mark-undelivered",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },

  {
    component: Master,
    route: "/middle-mile",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: Master,
    route: "/hub-in-scan",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: printEwayBill,
    route: "/print-eway-bill",
    role: [HUB_ADMIN, CP_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: Master,
    route: "/configuration-guide",
    role: [HUB_ADMIN, DEVELOPER],
  },

  {
    component: CreateOrUpdateTrip,
    route: "/create-or-update-trip",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },

  {
    component: ManifestList,
    route: "/manifest-list",
    role: [HUB_ADMIN, CP_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },

  {
    component: UpdateTripList,
    route: "/update-trip-list",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    component: Audits,
    route: "/audits",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: HubOnboarding,
    route: "/hub-onboarding",
    role: [HO_ADMIN, DEVELOPER],
  },

  {
    component: SortingGuide,
    route: "/sorting-guide",
    role: [HO_ADMIN, HUB_ADMIN, DEVELOPER],
  },

  {
    component: StaffOnboarding,
    route: "/staff-onboarding",
    role: [HO_ADMIN, CP_ADMIN, HUB_ADMIN, DEVELOPER],
  },
  {
    component: AuditTabs,
    route: "/manifest-audit",
    role: [HO_ADMIN, HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: DrsGeneration,
    route: "/generate-drs",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: printDrs,
    route: "/print-drs",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: DrsDetails,
    route: "/drs-details",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: PendingDrs,
    route: "/pending-drs",
    role: [CP_ADMIN, DEVELOPER],
  },

  {
    component: AuditScannedTable,
    // route: "/in-scan",
    route: "/audit-scanned",
    role: [HUB_ADMIN, DEVELOPER],
  },
  // {
  //   component: Packeting,
  //   route: "/packeting",
  //   role: [HUB_ADMIN, DEVELOPER],
  // },
  {
    component: ViewSortingMM,
    route: "/sort-shipment",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: Tracker,
    route: "/manifest-tracker/:id",
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, DEVELOPER],
  },
  // deepak's rout
  { component: CreateTrip, route: "/create-trip", role: [HUB_ADMIN, DEVELOPER] },
  { component: LcrTab, route: "/lcr-tab", role: [HUB_ADMIN, DEVELOPER] },
  { component: LCR, route: "/lcr-generation", role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER] },
  {
    component: LCRGenerationNew,
    route: "/new-lcr-generation",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: LCRReportNew,
    route: "/lcr-report",
    role: [HO_ADMIN, HUB_ADMIN, CP_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },

  { component: Bagging, route: "/shipment-bagging", role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER] },
  {
    component: LcrList,
    route: "/lcr-list",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    component: PrintLcr,
    route: "/print-lcr",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    component: ConsolidatedList,
    route: "/consolidated-manifest",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: PrintLcr,
    route: "/print-lcr",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    component: PrintConsolidatedManifest,
    route: "/print-consolidated-manifest/:id",
    role: [HUB_ADMIN, DEVELOPER],
  },

  {
    component: LCRListScan,
    route: "/lcr-list-in-scan",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    component: LCRScanList,
    route: "/lcr-scan-list",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },

  {
    component: SortToCp,
    route: "/sort-to-cp",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: OutscanManifestList,
    route: "/generateManifest",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: PrintGenerateManifest,
    route: "/print-generate-manifest/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: ExcesInscan,
    route: "/excess-inscan",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: VehicleList,
    route: "/vehicle-list",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: VehicleCkinCkout,
    route: "/vehicle-checkin-checkout",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    component: TripListByVehicle,
    route: "/vehicle-trip-list",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: Master,
    route: "/reports",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, CUSTOMER_DELIGHT_EXECUTIVE, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: CalendarView,
    route: "/trip-scheduler",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    component: TatConfiguration,
    route: "/tat-config",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: TatCalulator,
    route: "/tat-calculator",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: VehicleMaster,
    route: "/vehicle-master",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  // {
  //   component: ExcessInscan,
  //   route: "/excess-misrouted",
  //   role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  // },

  // cashRTo
  {
    component: CashRTo,
    route: "/cash-rto/:id",
    role: [HUB_ADMIN, HO_ADMIN, CP_ADMIN, DEVELOPER],
  },
  {
    component: CreditRTO,
    route: "/credit-rto/:id",
    role: [HUB_ADMIN, HO_ADMIN, CP_ADMIN, DEVELOPER],
  },
  {
    component: EwayTracker,
    route: "/eway-tracker/:id",
    // route: "/manifest-tracker/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: LeadDetails,
    route: "/lead-details/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: CPApprovalLeadList,
    route: "/cp-approval-lead-list",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },

  {
    component: CpOnboardingNew,
    route: "cp-details",
    // route: "/manifest-tracker/:id",

    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: ScheduleMeetingModal,
    route: "schedule-meeting",
    // route: "/manifest-tracker/:id",

    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: SendEmailModal,
    route: "send-mail",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: StateMaster,
    route: "/add-state-master",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: LeadApprovalConfirmation,
    route: "/lead-approval-confirmation/:id",

    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: BillingConfiguration,
    route: "/billing-config",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: RateCardList,
    route: "/rate-card-list",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: KycView,
    route: "kyc-view",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: RequestBranch,
    route: "request-for-branch",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },
  {
    component: CrediteBooking,
    route: "credit-booking",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_HOMARKETING, DEVELOPER],
  },

  //--//

  //--Middle Mile--//
  // {
  //   component: InScan,
  //   route: "/in-scan/:id",
  //   // route: "/manifest-in-scan",
  //   role: [HUB_ADMIN],
  // },
  // {
  //   component: AllManifestInScan,
  //   route: "/manifest-in-scan",
  //   // route: "/manifest-in-scan",
  //   role: [HUB_ADMIN],
  // },

  // {
  //   component: LCRBagInScan,
  //   route: "/lcr-bag-scan/:id",
  //   role: [HUB_ADMIN],
  // },

  // {
  //   component: OpenBag,
  //   route: "/lcr-bag-open/:id",
  //   role: [HUB_ADMIN],
  // },

  // {
  //   component: ClientOnboarding,
  //   route: "/client-onboarding",
  //   role: [CP_ADMIN],
  // },
  // {
  //   component: ClientTable,
  //   route: "/client-list",
  //   role: [CP_ADMIN, HO_ADMIN],
  // },
  // {
  //   component: ViewClientDetails,
  //   route: "/view-client/:id",
  //   role: [CP_ADMIN, HO_ADMIN],
  // },

  // {
  //   component: OnborginTabs,
  //   route: "/cp-onboarding",
  //   role: ["ROLE_HOADMIN"],
  // },
  // {
  //   component: Guides,
  //   route: "/guides",
  //   role: [HUB_ADMIN],
  // },
  // {
  //   component: ViewDetails,
  //   route: "/view-details",
  //   role: [HO_ADMIN, CP_ADMIN],
  // },
  // {
  //   component: Stationary,
  //   route: "/stationery",
  //   role: [HO_ADMIN, CP_ADMIN, HUB_ADMIN],
  // },

  //stationary
  {
    component: HoStationary,
    route: "/stationery",
    role: [HO_ADMIN, HUB_ADMIN, CP_ADMIN, DEVELOPER],
  },
  {
    component: AddCategory,
    route: "/add-category",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: AddProduct,
    route: "/add-product",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: ProductTabs,
    route: "/product",
    role: [HO_ADMIN, DEVELOPER],
  },

  {
    component: ProductCP,
    route: "/product-list",
    role: [CP_ADMIN, HUB_ADMIN, DEVELOPER],
  },
  {
    component: ProductDetails,
    route: "/product-details/:id",
    role: [CP_ADMIN, HUB_ADMIN, DEVELOPER],
  },
  {
    component: CartPage,
    route: "/cart-details",
    role: [CP_ADMIN, HUB_ADMIN, DEVELOPER],
  },
  {
    component: OrderRequest,
    route: "/order-request",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: OrderHistory,
    route: "/order-history",
    role: [CP_ADMIN, HUB_ADMIN, DEVELOPER],
  },
  {
    component: OrderDetails,
    route: "/order-details/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },

  {
    component: Discount,
    route: "/retail-discount",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: DiscountedList,
    route: "/retail-discounted-list",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: NewRetailUX,
    route: "/new-retail-ux",
    role: [CP_ADMIN, DEVELOPER],
  },
  {
    component: ShipmentListReport,
    route: "/shipment-report",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },

  {
    component: CPWiseHubManifestEWayBill,
    route: "/cp-wise-Eway/:id",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },

  {
    component: PrintManifest,
    route: "/cp-wise-manifest-print/:id",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },

  {
    component: ExceptionReport,
    route: "/exception-report",
    role: [HUB_ADMIN, DEVELOPER],
  },
  {
    component: ShipmentTracker,
    route: "/shipment-tracker",
    role: [HO_ADMIN, HUB_ADMIN, CP_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_CSO, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: LCRThreshold,
    route: "/lcr-threshold",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: AllReports,
    route: "/all_reports",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: HubToPinCodeMapping,
    route: "/hub-pincode-mapping",
    role: [HO_ADMIN, DEVELOPER],
  },
  {
    component: HubCpLinking,
    route: "/hub-cp-linking",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER],
  },
  {
    component: HubToCpMaster,
    route: "/hub-cp-master",
    role: [HUB_ADMIN, HO_ADMIN, DEVELOPER]
  },
  {
    component: DrsMaster,
    route: "/DRS-Master",
    role: [HUB_ADMIN, DEVELOPER]
  },
  {
    component: ReportTiles,
    route: "/dataReport",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: VayuQuickPincodeMapping,
    route: "/vayuquick-pincode-mapping",
    role: [HO_ADMIN, DEVELOPER, ROLE_CENTRALOPERATOR, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  //All Reports Routes
  {
    component: BookedVsAuditedReport,
    route: "/booked-vs-audited-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, ROLE_BOOKINGAUDITONLY, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: BookingStatusReport,
    route: "/booking-status-report",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: BookingInscanOutscanReport,
    route: "/booking-inscan-outscan-report",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: HubAuditEntryReport,
    route: "/hub-audit-entry-report",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: IncomingBagReport,
    route: "/incoming-bag-report",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: OutgoingBagReport,
    route: "/outgoing-bag-report",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: FastTrackReport,
    route: "/fast-track-report",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: DeliveryMISReport,
    route: "/delivery-mis-report",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: DeliveryMISReportNew,
    route: "/delivery-mis-report-new",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: DeliveryDetails,
    route: "/delivery-details",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: OutgoingShipmentReport,
    route: "/outgoing-shipment",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: IncomingShipmentReport,
    route: "/incoming-shipment-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: AccountBookings,
    route: "/account-bookings",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: CashBooking,
    route: "/cash-booking",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: HubOpsDashboard,
    route: "/hub-ops-dashboard",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: DeliveryDashboard,
    route: "/delivery-dashboard",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: DirectorDashboard,
    route: "/director-dashboard",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: BookingVolumeReports,
    route: "/booking-volume-reports",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: VayuQuickPro,
    route: "/vayuquick-pro",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: IncomingLCRReport,
    route: "/incoming-lcr",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_HUBOPERATOR, DEVELOPER]
  },
  {
    component: TransitLCRReport,
    route: "/transit-lcr",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: DeliveryStatusReport,
    route: "/delivery-status",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: OutscanVsCpInscanReport,
    route: "/outscan-cpinscan",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: OutscanByHubToBranch,
    route: "/outscan-by-hub-to-branch",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: DeliveryScanByBranch,
    route: "/delivery-scan-by-branch",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: SameDayDeliveryClickableReport,
    route: "/same-day-delivery-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: DrsByOtherCpReport,
    route: "/drs-by-other-cp",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: SameDayDeliveryByOtherCpReport,
    route: "/same-day-delivery-by-other-cp",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: NotInscannedByCpClickableReport,
    route: "/not-inscanned-by-cp-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: CpOutscanVsHubInscanReport,
    route: "/cp-outscan-vs-hub-inscan",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: HubInscanClickableReport,
    route: "/hub-inscan-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: CpOutscanClickableReport,
    route: "/cp-outscan-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: EwayBillReport,
    route: "/eway-bill-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: InscanReport,
    route: "/inscan-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: MCNReport,
    route: "/mcn-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: ForceShipmentReport,
    route: "/force-shipment-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: ForceBagReport,
    route: "/force-bag-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: WrongSortingReport,
    route: "/wrong-sorting-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: ForceAttemptBagReportCount,
    route: "/force-bag-attempt-shipment",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: ForceAttempShipmentDetails,
    route: "/force-attempt-shipment-details",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: IncomingOutGoingShipmentDetails,
    route: "/incoming-outgoing-shipment-details",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: HubAuditReport,
    route: "/hub-audit",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: OutgoingLCRReport,
    route: "/outgoing-lcr",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_HUBOPERATOR, DEVELOPER]
  },
  {
    component: InscanVsAuditReport,
    route: "/inscan-vs-audit-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: TotalAssignedClickableReport,
    route: "/total-assigned-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: InscannedAtTransitClickableReport,
    route: "/inscanned-at-transit-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: InscannedClickableReport,
    route: "/inscanned-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: HubInscannedClickableReport,
    route: "/hub-inscanned-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: TotalAuditedClickableReport,
    route: "/total-audited-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: NotAuditedClickableReport,
    route: "/not-audited-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, HO_ADMIN, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: TatAnalysisReports,
    route: "/tat-analysis-reports",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: PinCodeActiveInactiveTimelineReports,
    route: "/pin-code-active-inactive-timeline-reports",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: PincodeDiscrepanciesReport,
    route: "/pincode-discrepancies-report",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: DetailedInOutView,
    route: "/detailed-inout-view",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: mcnOutBond,
    route: "/mcn-out-bound",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: mcnInBond,
    route: "/mcn-in-bound",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: SmileLabelGeneration,
    route: "/smile-label-generation",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: ExcessInScanReport,
    route: "/excess-in-scan-report",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: ExcessInScanEnhancedReport,
    route: "/excess-in-scan-enhanced-report",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: FinalizedBagsPendingOutscanReport,
    route: "/finalized-bags-pending-outscan-report",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: APILog,
    route: "/api-log",
    role: [HO_ADMIN, DEVELOPER]
  },
  {
    component: BookingVsDeliveryReport,
    route: "/booking-vs-delivery-report",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: HubwiseShipmentsInscanVsOutscanReport,
    route: "/shipments-inscan-vs-outscan-report",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: ShipmentInscanClickableReport,
    route: "/shipment-inscan-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: ShipmentOutscanClickableReport,
    route: "/shipment-outscan-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: ShipmentPendingClickableReport,
    route: "/shipment-pending-clickable-report",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: ShipmentInscannedVsWeightAuditedAdherenceReport,
    route: "/shipment-inscanned-vs-weight-audited-adherence",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: AuditedDetailsReport,
    route: "/audited-details-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: TotalBookingsAuditReport,
    route: "/total-bookings-audit-report",
    role: [ROLE_MD, HUB_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },

  {
    component: ControlTowerReportsNew,
    route: "/control-tower-reports",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_CSO, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: TrainingVideo,
    route: "/training-videos",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_CENTRALOPERATOR, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: OdaDrsStatusUpdateAdoption,
    route: "/oda-drs-status-update-adoption",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  }
  ,
  {
    component: SupersetEmbeddedReport,
    route: "/embedded-report",
    role: [ROLE_MD, HUB_ADMIN, HO_ADMIN, DEVELOPER]
  },
  {
    component: DirectorDashboard2,
    route: "/director-dashboardNew",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: HubCPOverview,
    route: "/hub-overview",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, HO_ADMIN, DEVELOPER, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_CENTRALOPERATOR, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: HubManagerShipmentDetails,
    route: "/hub-manager-shipment-details",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, HO_ADMIN, DEVELOPER, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_CENTRALOPERATOR, ROLE_FUNCTIONALHEAD, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },

  {
    component: ZoneWiseView,
    route: "/zone-wise-shipment-counts",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: ZoneWiseView,
    route: "/zone-wise-delivery-data",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: HubWiseView,
    route: "/hub-wise-business-data",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: HubWiseView,
    route: "/hub-wise-shipment-counts",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: HubWiseView,
    route: "/hub-wise-delivery-data",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: CPWiseView,
    route: "/cp-wise-business-data",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: CPWiseView,
    route: "/cp-wise-shipment-counts",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: CPWiseView,
    route: "/cp-wise-delivery-data",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: ZoneList,
    route: "/zone-list",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: DirectorDashboard3,
    route: "/director-dashboardNew2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: HubOpsZoneWiseView,
    route: "/hub-ops-zone-wise2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: ZoneWiseView3,
    route: "/zone-wise-business-data2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: ZoneWiseView3,
    route: "/zone-wise-shipment-counts2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: ZoneWiseView3,
    route: "/zone-wise-delivery-data2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: HubWiseView3,
    route: "/hub-wise-business-data2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: HubWiseView3,
    route: "/hub-wise-shipment-counts2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: HubWiseView3,
    route: "/hub-wise-delivery-data2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: CPWiseView3,
    route: "/cp-wise-business-data2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: CPWiseView3,
    route: "/cp-wise-shipment-counts2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: CPWiseView3,
    route: "/cp-wise-shipment-counts2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: ZoneList3,
    route: "/zone-list2",
    role: [ROLE_MD, DEVELOPER]
  },
  {
    component: CentralOpsDashboard,
    route: "/central-ops-dashboard",
    role: [ROLE_FUNCTIONALHEAD]
  },
  {
    component: ZoneWiseViewCentralOps,
    route: "/central-ops/zone-wise-shipment-counts",
    role: [ROLE_FUNCTIONALHEAD]
  },
  {
    component: ZoneWiseViewCentralOps,
    route: "/central-ops/zone-wise-delivery-data",
    role: [ROLE_FUNCTIONALHEAD]
  },
  {
    component: HubWiseViewCentralOps,
    route: "/central-ops/hub-wise-shipment-counts",
    role: [ROLE_FUNCTIONALHEAD]
  },
  {
    component: HubWiseViewCentralOps,
    route: "/central-ops/hub-wise-delivery-data",
    role: [ROLE_FUNCTIONALHEAD]
  },
  {
    component: CPWiseViewCentralOps,
    route: "/central-ops/cp-wise-shipment-counts",
    role: [ROLE_FUNCTIONALHEAD]
  },
  {
    component: CPWiseViewCentralOps,
    route: "/central-ops/cp-wise-delivery-data",
    role: [ROLE_FUNCTIONALHEAD]
  },
  {
    component: ZoneListCentralOps,
    route: "/central-ops/zone-list",
    role: [ROLE_FUNCTIONALHEAD]
  },
  {
    component: Master,
    route: "/mcn",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: Master,
    route: "/locking-management-dashboard",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: Master,
    route: "/pending-awbs",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, DEVELOPER, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: TotalAvailableShipmentsClickableReport,
    route: "/total-available-shipments-clickable-report",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, HO_ADMIN, DEVELOPER, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_CENTRALOPERATOR, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: InboundPendencyClickableReport,
    route: "/inbound-pendency-clickable-report",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, HO_ADMIN, DEVELOPER, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_CENTRALOPERATOR, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: OutscanPendingInscanToHubClickableReport,
    route: "/outscan-pending-inscan-to-hub-clickable-report",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, HO_ADMIN, DEVELOPER, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_CENTRALOPERATOR, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: OutscanPendingInscanToCpClickableReport,
    route: "/outscan-pending-inscan-to-cp-clickable-report",
    role: [HUB_ADMIN, ROLE_HUBOPERATOR, HO_ADMIN, DEVELOPER, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_CENTRALOPERATOR, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: BookingReport,
    route: "/booking-report",
    role: [HO_ADMIN, ROLE_FUNCTIONALHEAD, ROLE_RM, ROLE_CENTRALOPERATOR, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM]
  },
  {
    component: RtoWithReasonReport,
    route: "/rto-with-reason-report",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: NonFtPremiumBookingsReport,
    route: "/non-ft-premium-bookings-report",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_CSO, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: InscannedBagsReport,
    route: "/inscanned-bags-report",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_CENTRALOPERATOR, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM],
  },
  {
    component: LiveTicketsPage,
    route: "/live-tickets",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_HUBOPERATOR, DEVELOPER],
  },
  {
    component: EscalationMatrix,
    route: "/escalation-matrix",
    role: [
      HO_ADMIN,
      DEVELOPER,
      ROLE_FUNCTIONALHEAD,
      HUB_ADMIN,
      ROLE_ZONALHEAD,
      ROLE_ZONALOPERATOR,
      ROLE_RM,
      ROLE_MD,
      ROLE_CENTRALOPERATOR,
      ROLE_BOOKINGAUDITONLY,
      ROLE_HUBOPERATOR,
      CP_ADMIN,
      ROLE_HOMARKETING,
      ROLE_CSO,
      ROLE_HOCRM, ROLE_HO_CRM_CP, ROLE_DPCRM,
    ],
  },
  {
    component: SupportAndContactView,
    route: "/support-and-contact",
    role: [HO_ADMIN, ROLE_CENTRALOPERATOR, DEVELOPER],
  },
  {
    component: HubOutscanVsCpInscanReportA3,
    route: "/hub-outscan-vs-cp-inscan-report-a3",
    role: [ROLE_CENTRALOPERATOR, DEVELOPER]
  },
  {
    component: HubOutscanVsCpInscanClickableA3,
    route: "/hub-outscan-vs-cp-inscan-clickable-a3",
    role: [ROLE_CENTRALOPERATOR, DEVELOPER]
  },
  {
    component: ReportConfigManager,
    route: "/report-config-manager",
    role: [DEVELOPER]
  },
  // ── Dynamic reports — one route serves ALL reports created in ReportConfigManager ──
  {
    component: DynamicReport,
    route: "/dynamic-report/:reportKey",
    role: [DEVELOPER]
  },
  // ── API Reports listing — auto-populated from ReportConfigManager ──
  {
    component: DynamicReportsList,
    route: "/api-reports",
    role: [DEVELOPER]
  },
];
